import { useEffect, useState } from 'react';
import './Toast.css';

export interface ToastMessage {
  id: string;
  text: string;
  type: 'success' | 'error';
}

interface ToastProps {
  messages: ToastMessage[];
  onDismiss: (id: string) => void;
}

export function Toast({ messages, onDismiss }: ToastProps) {
  return (
    <div className="toast-container" role="status" aria-live="polite">
      {messages.map((msg) => (
        <ToastItem key={msg.id} message={msg} onDismiss={onDismiss} />
      ))}
    </div>
  );
}

function ToastItem({ message, onDismiss }: { message: ToastMessage; onDismiss: (id: string) => void }) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setExiting(true);
      setTimeout(() => onDismiss(message.id), 200);
    }, 3000);
    return () => clearTimeout(timer);
  }, [message.id, onDismiss]);

  return (
    <div className={`toast-item toast-item--${message.type}${exiting ? ' toast-item--exiting' : ''}`}>
      <span className="toast-item__icon">{message.type === 'success' ? '✓' : '✕'}</span>
      <span className="toast-item__text">{message.text}</span>
    </div>
  );
}

let toastId = 0;
export function createToastId(): string {
  return `toast-${++toastId}-${Date.now()}`;
}
